<template>
  <section class="c-user-fiat-reports">
    <FilterTransactions
      @onSubmitFilter="handleFilter"
      title="فیلتر واریز های بانکی"
      :fromAssets="$store.getters.getAvailableFiatAssets"
      :toAssets="$store.getters.getAvailableFiatAssets"
      :asset="true"
    />

    <card class="data-card" :show-footer-line="true">
      <b-row no-gutters>
        <b-col>
          <h1 class="card-header p-0 card-header-text pb-3">
            فیلتر واریز های بانکی
          </h1>
        </b-col>
      </b-row>
      <b-skeleton-table
        v-if="loading"
        :rows="10"
        :columns="4"
        :table-props="{ bordered: true, striped: true }"
      >
      </b-skeleton-table>
      <b-row v-if="!loading">
        <b-col class="no-col-margin" md="12">
          <!-- <h1 class="section-header">کیف های پول</h1> -->
          <b-card class="wallets-table" no-body>
            <b-table
              emptyText="تاریخچه ای یافت نشد"
              :items="histories"
              :fields="fields"
              show-empty
              responsive
              small
            >
              <!-- <template #cell(status)="row">
                  <b-button size="sm" variant="outline-primary">{{
                    row.item.status
                  }}</b-button>
                </template> -->

              <template #cell(user)="row">
                <b-button @click="$router.push('/user-profile/'+row.item.user);">
                  نمایش جزییات کاربر
                </b-button>
              </template>

              <template #cell(shebaNumber)="row">
                {{ row.item.shebaNumber }}
              </template>

              <template #cell(amount)="row">
                {{ addCommas(row.item.amount) }}
              </template>

              <!--              <template #cell(identifier)="row">-->
              <!--                {{ row.item.identifier }}-->
              <!--              </template>-->

              <!--              <template #cell(amount)="row">-->
              <!--                {{ addCommas(row.item.amount) }}-->
              <!--              </template>-->

              <!--              <template #cell(requestDate)="row">-->
              <!--                {{row.item.requestDate}}-->
              <!--              </template>-->

              <template #cell(status)="row">
                <b-button size="sm" variant="outline-primary">
                  {{ row.item.status.label }}
                </b-button>
              </template>

              <!--              <template #cell(description)="row">-->
              <!--               {{row.items.description}}-->
              <!--              </template>-->

              <template #cell(actions)="row">
                <template v-if="adminsAccessOnly">


                  <b-button
                    @click="showModalApprove(row.item)"
                    class="ml-2"
                    v-if="row.item.status.value === 'Pending'"
                    size="sm" variant="primary">
                    تایید کردن
                  </b-button>

                  <b-button
                    @click="showModalReject(row.item)"
                    v-if="row.item.status.value === 'Pending'"
                    size="sm" variant="danger">
                    رد کردن
                  </b-button>
                </template>
              </template>
            </b-table>
          </b-card>
          <div class="paginationNav">
            <b-row>
              <b-col class="mt-4">
                <div class="overflow-auto">
                  <BasePagination
                    :showNext="showNext"
                    :showPrev="currentPage !== 0"
                    @onClick="handlePaginationClick"
                  />
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </card>

    <b-modal
      hide-footer
      v-model="rejectedObject.modal"
      title="رد کردن واریز بانکی"
    >
      <b-textarea
        placeholder="توضیحات"
        v-model="rejectedObject.description"/>
      <div class="d-flex align-items-center justify-content-between mt-4">
        <b-button @click="rejectedObject.modal = false">
          بستن
        </b-button>

        <base-button
          @click="rejectItem"
          :loading="rejectedObject.loading"
          :disabled="!rejectedObject.description"
          variant="primary">
          تایید
        </base-button>
      </div>
    </b-modal>
    <b-modal
      hide-footer
      v-model="approvedObject.modal"
      title="تایید کردن واریز بانکی"
    >
      <div>
        <h4>
          آیا مطمئن هستید ؟
        </h4>
      </div>
      <div class="d-flex align-items-center justify-content-between mt-4">
        <b-button @click="approvedObject.modal = false">
          بستن
        </b-button>

        <base-button
          @click="approveItem"
          :loading="approvedObject.loading"
          variant="primary">
          تایید
        </base-button>
      </div>
    </b-modal>

  </section>
</template>

<script>
import http from "@/httpservices/HttpService"
import CryptoIcons from "@/components/CryptoIcons";
import BasePagination from "@/components/BasePagination.vue";
import filterAndPaginate from "@/mixins/filterAndPaginate";
import FilterTransactions from "@/components/FilterTransactions";
import dateHelper from "@/utils/DateHelper";
import store from "@/store";
import {addCommas} from '@persian-tools/persian-tools'
import moment from "jalali-moment";
import Swal from "sweetalert2";

export default {
  mixins: [filterAndPaginate],

  components: {
    CryptoIcons,
    FilterTransactions,
    BasePagination,
  },

  computed: {
    adminsAccessOnly() {
      return Boolean(store.getters['isSuperAdmin'] || store.getters['isApprovingManager']);
    }
  },

  data() {
    return {
      pages: 1,
      page: 0,
      fields: [
        {
          key: "shebaNumber",
          label: "شماره شبا",
        },
        {
          key: "identifier",
          label: "شناسه تراکنش",
        },
        {
          key: "amount",
          label: "مبلغ",
        },
        {
          key: "requestDate",
          label: "تاریخ",
        },
        {
          key: "status",
          label: "وضعیت",
        },
        {key: "actions", label: "فعالیت"},
        {
          key: "description",
          label: "توضیحات",
        },
      ],
      histories: [],
      loading: false,
      rejectedObject: {
        loading: false,
        modal: false,
        description: "",
        id: "",
      },
      approvedObject: {
        loading: false,
        modal: false,
        id: "",
        accountId: "",
      },
    };
  },

  mounted() {
    this.getHistory();
  },

  methods: {
    addCommas,
    async getHistory() {
      this.loading = true;
      const {data} = await http.get(`/AdminReports/manual-fiat-deposit/page/0/`, {
        params: {
          AccountId: this.$route.params.id,
          PageSize: 1000,
        }
      });

      const status = {
        pending: "در حال بررسی",
        approved: "تایید شده",
        rejected: "رد شده"
      }

      this.histories = data.data.map(item => {
        return {
          id: item.id,
          shebaNumber: item.shebaNumber,
          identifier: item.identifier,
          amount: item.amount,
          description: item.description,
          created: item.created,
          requestDate: moment.utc(item.requestDate).locale('fa').format('jYYYY-jMM-jDD HH:mm'),
          status: {
            value: item.status,
            label: status[item.status.toLowerCase()],
          },
        }
      })
      console.log({data})
      this.loading = false;
    },

    showModalReject(item) {
      this.rejectedObject = {
        ...this.rejectedObject,
        loading: false,
        modal: true,
        description: "",
        id: item.id,
      }
    },
    async rejectItem() {
      this.rejectedObject.loading = true;
      try {
        await http.post('ManualFiatDeposit/reject', {
          "depositId": this.rejectedObject.id,
          "description": this.rejectedObject.description,
        });
        this.rejectedObject.modal = false;
        await Swal.fire({
          title: "انجام شد.",
          icon: "success",
          confirmButtonText: "باشه"
        });
        await this.getHistory();

      } catch (e) {
        console.log(e)
      }
      this.rejectedObject.loading = false;

    },

    showModalApprove(item) {
      this.approvedObject = {
        ...this.approvedObject,
        loading: false,
        modal: true,
        description: "",
        id: item.id,
        accountId: this.$route.params.id,
      }
    },

    async approveItem() {
      this.approvedObject.loading = true;
      try {
        await http.post('ManualFiatDeposit/approve', {
          "depositId": this.approvedObject.id,
          "accountId": this.approvedObject.accountId
        });
        await Swal.fire({
          title: "انجام شد.",
          icon: "success",
          confirmButtonText: "باشه"
        });
        await this.getHistory();

      } catch (e) {
        console.log(e)
      }
      this.approvedObject.loading = false;
      this.approvedObject.modal = false;
    },


  },
};
</script>

<style lang="scss">
.card-detail-container {
  .row {
    margin-bottom: 18px;
  }

  .last {
    margin-bottom: 0;
  }

  .info {
    font-size: 16px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #757575;
    text-align: right;
    margin-bottom: 8px;
  }

  .value {
    font-size: 16px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #000;
    text-align: left;
  }
}

.bank-logo {
  width: 34px;
  height: 34px;
}

.more-info-header-button {
  background-color: #fff;
}
</style>

<style lang="scss" scoped>
@media (max-width: 990px) {
  .section-header {
    font-size: 24px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #757575;
    margin-bottom: 49px;
  }
}

@media (min-width: 990px) {
  .section-header {
    font-size: 24px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #757575;
    margin-bottom: 49px;
  }
}

.data-card {
  @media (max-width: 991px) {
    margin-top: 16px;
  }
}

#add-card-modal {
  .modal-body {
    text-align: right;
    direction: rtl;
  }
}
</style>
